import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiClient } from '@/lib/apiClient'
import { API_ROUTES, PAGINATION } from '@/constants/apiRoutes'
import { HistoryManagementList } from '@/types/index'

// Async thunk to fetch user list with optional filters
export const getHistoryList = createAsyncThunk<HistoryManagementList, { tableName?: string, targetId?: string, operatorId?: string, page?: number, pageSize?: number }>(
    `${API_ROUTES.ADMIN_HISTORY_LIST_ENDPOINT}`,
    async ({ tableName, targetId, operatorId, page, pageSize }) => {
        // Map sang key BE yêu cầu
        const rawParams = {
            table: tableName,
            target_id: targetId,
            operator_id: operatorId,
            page,
            page_size: pageSize,
        };

        // Remove undefined or empty string parameters
        const params = new URLSearchParams();
        Object.entries(rawParams).forEach(([key, value]) => {
            if (value !== undefined && value !== '') {
                params.append(key, String(value));
            }
        });

        // API call to fetch user list
        const res = await apiClient.get<HistoryManagementList>(
            `${API_ROUTES.ADMIN_HISTORY_LIST_ENDPOINT}?${params.toString()}`
        );
        return res;
    })


// Initial state
const initialState: HistoryManagementList = {
    items: [],
    total: 0,
    page: PAGINATION.PAGE,
    page_size: PAGINATION.PAGE_SIZE,
    status: '',
    error: null,
    loading: false,
    message: '',
};

// slice definition
const historyManagementSlice = createSlice({
    name: 'historyManagement',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getHistoryList.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.status = 'loading';
            })
            .addCase(getHistoryList.fulfilled, (state, action) => {
                state.items = action.payload.items || [];
                state.page = action.payload.page || PAGINATION.PAGE;
                state.page_size = action.payload.page_size || PAGINATION.PAGE_SIZE;
                state.total = action.payload.total || 0;
                state.loading = false;
                state.status = 'success';
                state.message = action.payload.message || '';
            })
            .addCase(getHistoryList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Failed to fetch history list';
                state.status = 'error';
            });
    },
});

export default historyManagementSlice.reducer;
